module.exports = __webpack_public_path__ + "img/birthday-logo-decs.42023ff.svg?v=1757575323155";